/**
 * @generated
 * @file Checkbox (generated by DevLink)
 *
 * This file is generated by DevLink from a Webflow component. Manual edits are discouraged.
 *
 * @see {@link https://ticketing-2-0.design.webflow.com | Source site in Webflow}
 */
"use client";

import { DEVLINK_SCOPE_CLASS } from "./devlinkScope";
import Block from "./webflow_modules/Basic/components/Block";
import FormCheckboxInput from "./webflow_modules/Form/components/FormCheckboxInput";
import FormCheckboxWrapper from "./webflow_modules/Form/components/FormCheckboxWrapper";
import FormInlineLabel from "./webflow_modules/Form/components/FormInlineLabel";

/**
 * Props for {@link Checkbox}
 */
export type CheckboxProps = {
  checkboxRuntimeProps?: Record<string, unknown>;
  helperText?: React.ReactNode;
  label?: React.ReactNode;
  variant?: "light mode" | "dark mode";
  visibility?: boolean;
};

/**
 * Checkbox
 *
 * @see {@link https://ticketing-2-0.design.webflow.com | Source site in Webflow}
 */
export function Checkbox({
  checkboxRuntimeProps = {},
  helperText = "This is some text inside of a div block.",
  label = "Checkbox",
  variant = "light mode",
  visibility = false,
}: CheckboxProps) {
  const _styleVariantMap = {
    "light mode": "",
    "dark mode": "w-variant-fa4c80a8-b4a0-8d2a-9b4b-bb954d3e0506",
  };

  const _activeStyleVariant = _styleVariantMap[variant];

  return (
    <div
      className={DEVLINK_SCOPE_CLASS}
      style={{
        display: "contents",
      }}
    >
      <FormCheckboxWrapper className={`checkbox_field ${_activeStyleVariant}`}>
        <FormCheckboxInput
          checked={false}
          className={`checkbox_button ${_activeStyleVariant}`}
          customClassName={"w-checkbox-input--inputType-custom"}
          data-name={"Checkbox"}
          form={{
            type: "checkbox-input",
            name: "Checkbox",
          }}
          id={"Checkbox"}
          inputType={"custom"}
          name={"Checkbox"}
          required={false}
          type={"checkbox"}
          {...checkboxRuntimeProps}
        />
        <FormInlineLabel className={`checkbox-field ${_activeStyleVariant}`}>
          {label}
        </FormInlineLabel>
        {visibility ? (
          <Block
            className={`text-size-small text-color-graydark ${_activeStyleVariant}`}
            tag={"div"}
          >
            {helperText}
          </Block>
        ) : null}
      </FormCheckboxWrapper>
    </div>
  );
}
